module.exports = __webpack_public_path__ + "img/men_strong.1af07265.png";